import { ThemeSelectors } from "@at/design-system-foundation";
import styled from "styled-components";

export const ContractSwitchWrapper = styled.div`
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  margin-top: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
`;
